import React from 'react';
import { isLength } from 'validator';

import { ArrowToggle } from '../organism/Toggle';
import { VerticalImageInputRadioList } from '../organism/InputRadioList';
import { BoxBottomGrey, Layout, OrderTemplate } from './OrderTemplate';

import ImageUpload, { ULTRASOUND } from '../../../domain/image/ImageUpload';
import {
  BabyfaceFirstInfo,
  BabyfaceSecondInfo,
  DeliveryInfo,
  MessageToBaby,
} from '../../../domain/order/Item/OrderInfoInput';
import { PreviewFrame } from '../../../domain/Frame/FrameView';
import { ERROR_VALIDATE_ORDER } from '../../../lib/Error';
import {
  MYPAGE_ORDER_DETAIL_MENU,
  MYPAGE_ORDER_MENU,
} from '../../../lib/routes/MyPageRoutes';
import {
  FINAL_EXAMPLE_PICTURE,
  ULTRASOUNDIMAGE_EXAMPLE_PICTURE,
} from '../../../lib/image/OrderImages';

const BabyfaceOrderTemplate = ({
  message,
  note,
  name,
  mobile,
  zipcode,
  address,
  detailAddress,
  babyGender,
  hospitalName,
  pay_method,
  finalPrice,
  onChange,
  onClickAddHeart,
  onAddress,
  selectGender,
  onCheck,
  onPayMethod,
  pg,
  frames,
  onSelectFrame,
  previewFrame,
  selectedFrame,
  previewFrameName,
  onSelectVoucherCoupon,
  defaultPrice,
  finalShippingFee,
  shipmentRequired,
  onSelectAccount,
  allowMarketing,
  allowMarketingInitialValue,
  handleAllowMarketing,
}) => {
  return (
    <OrderTemplate
      onChange={onChange}
      onCheck={onCheck}
      finalPrice={finalPrice}
      onSelectAccount={onSelectAccount}
      onPayMethod={onPayMethod}
      onSelectVoucherCoupon={onSelectVoucherCoupon}
      pay_method={pay_method}
      pg={pg}
      finalShippingFee={finalShippingFee}
      discountPrice={defaultPrice - (finalPrice - finalShippingFee)}
      defaultPrice={defaultPrice}
      payback
      allowMarketing={allowMarketing}
      allowMarketingInitialValue={allowMarketingInitialValue}
      handleAllowMarketing={handleAllowMarketing}
    >
      <BabyfaceFirstInfo
        title="3. 초음파 사진 업로드"
        babyGender={babyGender}
        disabled={false}
        onChangeBabyGender={selectGender}
        onChangeHospitalName={onChange}
        hospitalName={hospitalName}
        note={note}
        onChangeNote={onChange}
        required
      >
        <BoxBottomGrey>
          <ImageUpload
            imageType={ULTRASOUND}
            multipleOption={false}
            limitedNum={1}
            preloadImages={sessionStorage.be_ultrasound && [sessionStorage.be_ultrasound]}
            indelible={sessionStorage.be_ultrasound}
          />
          {!sessionStorage.be_ultrasound && <ArrowToggle content={ULTRASOUND_DESCRIPTION} />}
        </BoxBottomGrey>
      </BabyfaceFirstInfo>
      <BabyfaceSecondInfo title="4. 프레임 선택" required>
        <>
          {frames !== null && (
            <VerticalImageInputRadioList
              radioData={frames.map((frame) => ({
                id: frame.id,
                src: frame.lookAndFeelImage.storageUri,
                checked: selectedFrame === frame.alias,
                onChange: () =>
                  onSelectFrame({
                    selectedFrame: frame.alias,
                    previewImage: frame.previewImage.storageUri,
                    previewFrameName: frame.meta.name,
                  }),
              }))}
            />
          )}
          {previewFrame !== null && (
            <PreviewFrame
              previewFrameName={previewFrameName}
              previewFrame={previewFrame}
            />
          )}
        </>

        <BoxBottomGrey>
          <MessageToBaby
            onClickAddHeart={onClickAddHeart}
            message={message}
            onChangeMessage={onChange}
            disabled={false}
          />
          <ArrowToggle content={FRAME_DESCRIPTION} />
        </BoxBottomGrey>
      </BabyfaceSecondInfo>
        <Layout title={shipmentRequired ? "5. 배송지 정보" : "5. 신청자 정보"} required>
          <DeliveryInfo
            onAddress={onAddress}
            onChange={onChange}
            shipmentRequired={shipmentRequired}
            state={{
              name,
              mobile,
              detailAddress,
              zipcode,
              address,
              nameError: !isLength(name, { min: 2, max: 10 })
                ? ERROR_VALIDATE_ORDER['name']
                : null,
              mobileError: !isLength(mobile, { min: 10, max: 11 })
                ? ERROR_VALIDATE_ORDER['mobile']
                : null,
              detailAddressError: !isLength(detailAddress, { min: 1 })
                ? ERROR_VALIDATE_ORDER['detailAddress']
                : null,
            }}
          />
        </Layout>
    </OrderTemplate>
  );
};

export default BabyfaceOrderTemplate;

const ULTRASOUND_DESCRIPTION = [
  {
    id: 1,
    title: <b>초음파 사진 가이드 보기 (필독)</b>,
    description: [
      `<img src=${ULTRASOUNDIMAGE_EXAMPLE_PICTURE} width="100%" />`,
      '- <b>분석을 원하는 입체초음파 사진 1장</b>만 올려주세요.',
      '- <b>25주 이상</b> 지나 촬영한 입체 초음파 사진을 올려주세요. <b>(흑백, 컬러 모두 가능)</b>',
      '- 인화된 사진을 촬영하여 올려주셔도 됩니다.',
      '- 초음파 노이즈, 반사광이 심한 경우 등 초음파 사진의 상태에 따라 아기의 모습이 제대로 보이지 않을 수 있습니다. 이와 같이 <b>아기 미리보기 서비스를 할 수 없는 경우, 분석 결과 자동으로 환불</b>처리가 될 수 있습니다.',
    ],
  },
];

const FRAME_DESCRIPTION = [
  {
    id: 2,
    title: <b>결과물 및 문구 예시 (필독)</b>,
    description: [
      `<img src=${FINAL_EXAMPLE_PICTURE} width="100%" />`,
      '- ‘분석완료’와 ‘인쇄 후’에는 <b>수정이 불가능</b>합니다. 신중하게 선택해주세요.',
      '- 프레임을 선택하지 않은 경우, <b>기본 프레임</b>으로 제공됩니다.',
      '- 아기에게 보내는 메시지에 이모지는 지원하지 않으며, <b>이모지 입력 시 검정 하트로 자동 전환</b>됩니다.',
      `- 주문 후 분석이 완료되기 전에는 <b>${MYPAGE_ORDER_MENU.label} > ${MYPAGE_ORDER_DETAIL_MENU.label} > 수정하기</b>에서 수정이 가능합니다.`,
    ],
  },
];
